import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

import { SxProps, Theme } from '@mui/material';
import RadioSelectItem from 'components/radio-select-item';
import Select from 'components/select';
import { useAccountState } from 'contexts/account/account-context';
import { useIntl } from 'react-intl';
import _ from 'underscore';
import { usePondsState } from 'views/production-systems/context/ponds-context';
import { useGet } from 'hooks/use-get';
import { getCompanyInfo } from '../api/productionSystems';

type Props = {
  selectedId: string;
  uri: string;
  dark?: boolean;
  sx?: SxProps<Theme> | undefined;
  onChange?: () => void;
};

const SelectFarm: React.FC<Props> = ({ selectedId, uri, dark, onChange, sx }) => {
  const history = useHistory();
  const intl = useIntl();
  const { account } = useAccountState();
  const { setSelectedPonds } = usePondsState();
  // #region STATE

  const [pondSearchValue, setPondSearchValue] = useState<string>('');
  const [pondName, setPondName] = useState<string>('');

  // #endregion STATE

  const { data: companyData, isLoading } = useGet(
    ['getCompanyInfo', account.company?.companyId],
    ({ queryKey }) => getCompanyInfo(String(queryKey[1])),
    {
      enabled: !!account.company?.companyId,
    }
  );

  const ponds = _.chain(companyData).sortBy('name').value()

  //#region HOOKS

  useEffect(() => {
    if (!!selectedId) {
      let pond = ponds?.find((s) => s.globalSiteId === selectedId);
      setPondName(pond?.name || '');
    } else setPondName('');
  }, [selectedId, ponds]);

  // #endregion HOOKS

  return (
    <Select
      sx={sx}
      tooltipTitle={pondName}
      label={intl.formatMessage({ id: 'productionSystems.selectFarm' })}
      value={selectedId}
      search={{
        value: pondSearchValue,
        onChange: setPondSearchValue,
      }}
      dark={dark}
      onOpen={() => {
        setPondSearchValue('');
      }}
      onChange={(event) => {
        setSelectedPonds([]);
        history.push(`${uri}/${event.target.value as string}`);
        if (onChange) onChange();
      }}>
      {_.chain(ponds)
        .filter((pond) => pond.name.toLowerCase().includes(pondSearchValue))
        .sortBy((s) => s.name.toLowerCase())
        .value()
        .map((pond, idx) => (
          <RadioSelectItem key={pond.globalSiteId} value={pond.globalSiteId} onClick={() => setPondName(pond.name)} selected={pond.globalSiteId === selectedId}>
            {pond.name}
          </RadioSelectItem>
        ))}
    </Select>
  );
};

export default SelectFarm;
